export default {
    methods:
        isTextFieldSet: (field) ->
            field and field.length and field[0].text
}